import React from 'react'
import { PageDefinition, PageType } from 'pages/pageDefinition'
import { AuditComponent } from 'components/audit'
import { usePageViewAudit } from 'hooks/usePageViewAudit'

const Route = '/support/audit'
const PageTitle = 'Audit Trail'

const PageComponent: React.FunctionComponent = () => {
  usePageViewAudit(PageTitle, true, true)

  return <AuditComponent />
}

export const AuditPage: PageDefinition = {
  routes: () => [Route],
  type: [PageType.Support],
  sortOrder: () => 2,
  component: <PageComponent />,
  pageTitle: PageTitle,
  navLinkText: PageTitle,
  canAccess: (user) => user?.isSupport === true,
  buildNavLink: (_) => Route,
}
